import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Redirect, RouteProps, RouteComponentProps } from 'react-router-dom';

import { APICore } from '../helpers/api/apiCore';
import { AppDispatch } from '../redux/store';
import { getShop, setUrlShopName } from '../redux/actions';

interface PrivateRouteProps {
    component: React.FunctionComponent<RouteProps>;
    roles?: string;
}

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */
const PrivateRoute = ({ component: Component, roles, ...rest }: PrivateRouteProps) => {
    const api = new APICore();
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        let shopName = rest.computedMatch?.params?.name
        dispatch(setUrlShopName(shopName))
        if (shopName) {
            dispatch(getShop(shopName))
        }
    }, [])

    return (
        <Route
            {...rest}
            render={(props: RouteComponentProps) => {

                if (api.isUserAuthenticated() === false) {
                    // not logged in so redirect to login page with the return url
                    // dispatch(resetAuth());
                    return (
                        <Redirect
                            to={{
                                pathname: '/auth/login',
                                state: { from: props['location'] },
                            }}
                        />
                    );
                }

                const loggedInUser = api.getLoggedInUser();

                // check if route is restricted by role
                if (roles && roles.indexOf(loggedInUser.role?.name) === -1) {
                    // role not authorised so redirect to home page
                    return <Redirect to={{ pathname: '/' }} />;
                }
                // authorised so return component
                return <Component {...props} />;
            }}
        />
    );
};

export default PrivateRoute;
